/**
 * Dependencies
 */
import moment from 'moment'

/**
 * Return the date format
 *
 * @param  {Object} state
 * @return {String]}
 */
const dateFormat = (state) => {
    switch (state.histogram.type) {
        case 'week':
            return 'W'
        case 'day':
            return 'M-D-YYYY'
        case 'month':
            return 'MMM'
        case 'year':
            return 'YYYY'
        case 'hour':
            return 'h:ms a'
        case 'minute':
            return 'm'
        case 'second':
            return 's'
        default:
            return 'M-D-YYYY'
    }
}

const buildDataContext = (label, data, idx) => {
    let colors = [
        '255,99,132',
        '75,192,192',
        '230,126,34',
        '142,68,173',
        '22,160,133',
        '255,206,86',
        '54,162,235'
    ]

    return {
        label: label,
        fill: true,
        lineTension: 0.1,
        backgroundColor: `rgba(${colors[idx]},0.4)`,
        borderColor: `rgba(${colors[idx]},0.7)`,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: `rgba(${colors[idx]},1)`,
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: `rgba(${colors[idx]},1)`,
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: data.map(item => item.num_events),
        spanGaps: false
    }
}

/**
 * Transform API data into chart-renderable context
 *
 * @param  {Object} state
 * @return {Array}
 */
const histogramChartData = (state) => {
    let data = state.histogram.data
    let format = state.histogram.options.find(item => item.key === state.histogram.type).format

    return Object.keys(data).reduce((payload, key, idx) => {
        let labels = data[key].map(item => moment(item.datetime).format(format))
        let context = buildDataContext(key, data[key], idx)

        if (labels.length > 0) {
            payload.labels = labels
        }

        payload.datasets.push(context)

        return payload
    }, { labels: [], datasets: [] })
}

/**
 * Selected Type
 *
 * @param  {Object} state
 * @return {String}
 */
const selectedType = (state) => {
    return state
        .histogram
        .options
        .find(item => item.key === state.histogram.type)
        .label
}

/**
 * Concatenated list of selected activity contexts suitable for HTTP payload
 *
 * @param  {Object} state
 * @return {String}
 */
const contextQueryString = (state) => {
    return state.context.join(',')
}

/**
 * Check to see if geolocation array is empty
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasHeatMapData = (state) => state.geolocation.length > 0

export default {
    dateFormat,
    selectedType,
    hasHeatMapData,
    histogramChartData,
    contextQueryString
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/activity/getters.js